export const GUIDE_MEDIA_BUCKET = (import.meta.env.VITE_GUIDE_MEDIA_BUCKET || "guide-media") as string;
export const STATE_MEDIA_BUCKET = (import.meta.env.VITE_STATE_MEDIA_BUCKET || 'state-media') as string;
export const MAIL_MEDIA_BUCKET = (import.meta.env.VITE_MAIL_MEDIA_BUCKET || 'mail-media') as string;
export const ALLIANCE_BANNERS_BUCKET = (import.meta.env.VITE_ALLIANCE_BANNERS_BUCKET || 'alliance-banners') as string;

